import React from 'react';
import { useState, useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import NairaIcon from './NairaIcon';
import { useNavigate } from "react-router-dom";

const NicmlProductList = () => {
    const navigate = useNavigate()

    const products = [
        {
            "name": "Classic Note",
            "description": "Earn interest on your investments in periodic intervals through our Targeted and Structured Classic Investment Note.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Classic-Investment-Note-min.jpg",
            "id": "classic"
        },
        {
            "name": "Treasury Linked Note",
            "description": "Invest in Treasury Bills and earn upfront returns on your investment, with the principal at the end of the investment.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Treasury-Linked-Note-min.jpg",
            "id": "TLN"
        },
        {
            "name": "Medium Term Investment Note",
            "description": "For Investors seeking medium-long term investment options that provide superior returns and periodic interest payment.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Norren-Medium-Term-Investment-Note-min.jpg",
            "id": "MTIN"
        },
        {
            "name": "FX Classic Investment Note",
            "description": "Invest in foreign currencies over a short tenor to hedge against currency risk while earning returns on your investment.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Discretionary-FX-Investment-Options-min.jpg",
            "id": "FXclassic"
        },
        {
            "name": "KickStart Account",
            "description": "Invest in Securing the future of your ward by getting started with The Norrenberger Kickstart account today.",
            "image": "https://norrenberger.com/wp-content/uploads/2022/12/Rectangle-65-min.png",
            "id": "kickstart"
        },
        {
            "name": "Corper Invest",
            "description": "Encourages Corp members to start future  planning by investing in low risk asset classes to generate competitive returns.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Corper-Invest-min.jpg",
            "id": "CI"
        },
        {
            "name": "Discretionary money market/SME",
            "description": "Invest in Money Market Instrument to provide flexibility to investors seeking fixed and competitive returns.",
            "image": "https://norrenberger.com/wp-content/uploads/2023/03/Discretionary-Money-Market-Investment-min.jpg",
            "id": "DMM"
        }
    ];

    const [selectedProduct, setSelectedProduct] = useState("")
    const [selectedID, setSelectedID] = useState("")
    const [investmentAmount, setInvestmentAmount] = useState("")
    const [flutterWaveKey, setFlutterWaveKey] = useState("")


    let name
    let email
    let payload

    if (sessionStorage.getItem('individualData')) {
        payload = JSON.parse((sessionStorage.getItem('individualData')))
        // console.log("payload",payload)
        name = payload.first_name + " " + payload.last_name
        email = payload.primary_email_address
    }
    else if (sessionStorage.getItem('Corporate')) {
        payload = JSON.parse((sessionStorage.getItem('Corporate')))
        // console.log("payload",payload)
        name = payload.organization_name
        email = payload.primary_email_address
    }
    else {
        navigate('https://onboarding.norrenberger.com')
    }


    // flutterwave keys.
    // const classic = "FLWPUBK-02be49425aa1c7a5a11b501485a9d084-X"
    // const NMMF = "FLWPUBK-6e78e0d0118b7e89b177e78537b36ea9-X"
    // const TLN = "FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X"
    // const MTIN = "FLWPUBK-93d66521d8e02fc729062e74763c8f2b-X"
    // const FXclassic = "FLWPUBK-fbbf1264b20912a92184653d2492c33f-X"
    // const TM = "FLWPUBK-67667fc79edea1bf1f88098bcf038b02-X"
    // const kickstart = "FLWPUBK-3613bbcb430a29c20e9df6229a4b2ad6-X"
    // const CI = "FLWPUBK-4c2c5a084d69c4b272cc98bfa23511a8-X"
    // const DMM = "FLWPUBK-fc562af2c28cc783084ee6c176f32031-X"

    // let flutterWaveKey = ""
    var fwKey = "none"
    const handleCheckout = (id, productName) => {

        setSelectedProduct(productName)
        setSelectedID(id)
        setInvestmentAmount("")

        // if(id === "classic"){
        //     fwKey = "FLWPUBK-02be49425aa1c7a5a11b501485a9d084-X" 
        // }
        if (id === "classic") {
            setFlutterWaveKey("FLWPUBK-02be49425aa1c7a5a11b501485a9d084-X");
            fwKey = "FLWPUBK-02be49425aa1c7a5a11b501485a9d084-X"
        }
        else if (id === "NMMF") {
            setFlutterWaveKey("FLWPUBK-6e78e0d0118b7e89b177e78537b36ea9-X");
            fwKey = "FLWPUBK-6e78e0d0118b7e89b177e78537b36ea9-X"
        }
        else if (id === "TLN") {
            setFlutterWaveKey("FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X");
            fwKey = "FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X"
        }
        else if (id === "MTIN") {
            setFlutterWaveKey("FLWSECK-7b070ca6f67befc231c97d7867f5de64-X");
            fwKey = "FLWSECK-7b070ca6f67befc231c97d7867f5de64-X"
        }
        else if (id === "FXclassic") {
            setFlutterWaveKey("FLWPUBK-fbbf1264b20912a92184653d2492c33f-X");
            fwKey = "FLWPUBK-fbbf1264b20912a92184653d2492c33f-X"
        }
        else if (id === "TM") {
            setFlutterWaveKey("FLWPUBK-67667fc79edea1bf1f88098bcf038b02-X");
            fwKey = "FLWPUBK-67667fc79edea1bf1f88098bcf038b02-X"
        }
        else if (id === "kickstart") {
            setFlutterWaveKey("FLWPUBK-3613bbcb430a29c20e9df6229a4b2ad6-X");
            fwKey = "FLWPUBK-3613bbcb430a29c20e9df6229a4b2ad6-X"
        }
        else if (id === "CI") {
            setFlutterWaveKey("FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X");
            fwKey = "FLWPUBK-4c2c5a084d69c4b272cc98bfa23511a8-X"
        }
        else if (id === "DMM") {
            setFlutterWaveKey("FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X");
            fwKey = "FLWPUBK-fc562af2c28cc783084ee6c176f32031-X"
        }
        console.log(flutterWaveKey)
        console.log(selectedID)
        // console.log(fwKey)
    }

    return (
        <>
            <div>
                <h5 className="" style={{ marginBottom: "-5px" }}>Asset Management</h5>
                <small className="text-muted text-small mb-2">
                    Elevate Your Wealth: Unleash Opportunities, Secure Futures, Maximize Returns with Our Premier Asset Management Products
                </small>
                <br /><br />
                <OwlCarousel
                    items={4}
                    className="owl-theme"
                    loop
                    autoplay
                    autoplayTimeout={3000}
                    autoplayHoverPause
                    margin={8}
                >
                    {products.map((product, index) => (
                        <div key={index}>
                            <div className="card" style={{ display: "block", height: "500px !important" }}>
                                <img
                                    className="card-img-top"
                                    src={product.image}
                                    alt=""
                                    style={{ height: "130px", objectFit: "cover" }}
                                />
                                <div className="card-body" style={{ height: "300px !important" }}>
                                    <h6 className="card-title bold text-small">{product.name}</h6>
                                    <small className="card-text text-small text-secondary">{product.description}</small><br />
                                    <button className="btn-custom-sm mt-3" data-bs-toggle="modal" data-bs-target="#checkout" onClick={() => handleCheckout(product.id, product.name)}>Select <i className="bi-plus-circle ms-2"></i></button>
                                </div>
                            </div>
                        </div>
                    ))}
                </OwlCarousel >

                {/* MODAL CONTENT */}
                < div className="modal fade" id="checkout" >
                    <div className="modal-dialog modal-sm">
                        <div className="modal-content">
                            {/* <!-- Modal Header --> */}
                            <div className="modal-header">
                                <div>
                                    <h6 style={{ marginBottom: "-5px" }}>{selectedProduct}</h6>
                                    <small className="text-muted text-small">Selected Product</small>
                                </div>
                                <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                            </div>
                            {/* <!-- Modal body --> */}
                            <div className="modal-body">
                                <div className="">
                                    <div className="">
                                        <div className="my-2">
                                            <h6 style={{ marginBottom: "-5px" }}><NairaIcon /> {investmentAmount || "0.00"}</h6>
                                            <small className="text-muted text-small">Investment Amount</small>
                                        </div>
                                        <form method="POST" action="https://checkout.flutterwave.com/v3/hosted/pay">
                                            <input type="number" name="amount" className="form-control custom-input" value={investmentAmount} placeholder="Select Amount" onChange={(e) => setInvestmentAmount(e.target.value)} required />
                                            {/* <input type="hidden" name="public_key" value= /> */}
                                            {
                                                selectedID === "classic" && <input type="hidden" name="public_key" value="FLWPUBK-02be49425aa1c7a5a11b501485a9d084-X" /> ||
                                                selectedID === "NMMF" && <input type="hidden" name="public_key" value="FLWPUBK-6e78e0d0118b7e89b177e78537b36ea9-X" /> ||
                                                selectedID === "TLN" && <input type="hidden" name="public_key" value="FLWPUBK-500f952f6b9acffafa100c7fd7f5db37-X" /> ||
                                                selectedID === "MTIN" && <input type="hidden" name="public_key" value="FLWPUBK-93d66521d8e02fc729062e74763c8f2b-X" /> ||
                                                selectedID === "FXclassic" && <input type="hidden" name="public_key" value="FLWPUBK-fbbf1264b20912a92184653d2492c33f-X" /> ||
                                                selectedID === "TM" && <input type="hidden" name="public_key" value="FLWPUBK-67667fc79edea1bf1f88098bcf038b02-X" /> ||
                                                selectedID === "kickstart" && <input type="hidden" name="public_key" value="FLWPUBK-3613bbcb430a29c20e9df6229a4b2ad6-X" /> ||
                                                selectedID === "CI" && <input type="hidden" name="public_key" value="FLWPUBK-4c2c5a084d69c4b272cc98bfa23511a8-X" /> ||
                                                selectedID === "DMM" && <input type="hidden" name="public_key" value="FLWPUBK-fc562af2c28cc783084ee6c176f32031-X" /> 
                                            }

                                            {/* <input type="hidden" name="public_key" value="FLWPUBK_TEST-02b9b5fc6406bd4a41c3ff141cc45e93-X" /> */}

                                            <input type="hidden" name="customer[email]" value={email} />
                                            <input type="hidden" name="customer[name]" value={name} />
                                            <input type="hidden" name="tx_ref" value="txref-81123" />
                                            <input type="hidden" name="currency" value="NGN" />
                                            <input type="hidden" name="meta[source]" value="Norrenberger Product Onboarding" />

                                            <button type="submit" className="btn-custom w-100 mt-3" id="start-payment-button">Pay Now <i className="bi-chevron-right ms-2"></i></button>
                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div >

            </div >

        </>

    );
};

export default NicmlProductList;
